var map = {
	"./bg1_HIFI.jpg": "a588",
	"./bg1_YAMAHADAY.jpg": "9a04",
	"./bg1_band.jpg": "939e",
	"./bg1_bottom.jpg": "c143",
	"./bg1_concept.jpg": "2d64",
	"./bg1_ekb.jpg": "ed9e",
	"./bg1_guitar.jpg": "5e26",
	"./bg1_left.jpg": "b69c",
	"./bg1_piano.jpg": "0a94",
	"./bg1_pianoai.jpg": "86d2",
	"./bg1_right.jpg": "4a19",
	"./bg1_stage.jpg": "56ac",
	"./bg1_top.jpg": "d9f6",
	"./bg1_wind.jpg": "53c7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "084a";